import * as Sentry from "@sentry/remix";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import posthog from "posthog-js";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

Sentry.init({
  dsn: "https://f31bf6950400c8855c65ac9fa1faf7ee@o4508905675882496.ingest.us.sentry.io/4508905678241792",
  tracesSampleRate: 1,

  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
  ],
});

function PosthogInit() {
  useEffect(() => {
    posthog.init("phc_ly0Hf5Kmjk0ekuRqnswt5PlPzY3z1ZiqF3QMP2wFFXl", {
      api_host: "https://pineapple.manupgame.com",
      person_profiles: "always",
      debug: process.env.NODE_ENV === "development",
    });
  }, []);

  return null;
}
startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
      <PosthogInit />
    </StrictMode>
  );
});
